import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

export const OneWayNotice = () => {
  return (
    <div
      className={stack({
        align: 'start',
        gap: 8,
        py: 12,
        px: 16,
        mb: 10,
        rounded: 8,
        bg: 'background.default.level-1',
      })}
    >
      <Badge type='tint' color='accent'>
        <FormattedMessage id='Position_leverage.r260311.Adjust_leverage_one_way_mode' />
      </Badge>
      <p
        className={css({
          textStyle: 'Text/M/Regular',
          color: 'content.default.level-5',
        })}
      >
        <FormattedMessage id='Position_leverage.r260311.Adjust_leverage_disclaimer' />
      </p>
    </div>
  );
};
